import { useAppSelector } from "../redux/features/hooks";
import { Navigate, useLocation } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { isKitchenOnly, kitchenOnlyMayReach } from "@/lib/navigation";

const ProtectedPage = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const currentUser = useAppSelector((state) => state.user.currentUser);
  const location = useLocation();
  const { canAny } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // Kitchen-only users stay on /kitchen and /orders, plus the permission-gated
  // sections they hold a permission for (src/lib/navigation.ts).
  if (
    isKitchenOnly(currentUser?.roles) &&
    !kitchenOnlyMayReach(location.pathname, canAny)
  ) {
    return <Navigate to="/kitchen" replace />;
  }

  return children;
};

export default ProtectedPage;
